import { useCallback } from 'react'
import { useMatchMedia } from '@revolut-internal/ui-kit'
import { useLocalStorage } from 'react-use'

import { LocalStorageKeys } from 'lib/shared/consts'

export function useDarkMode() {
  const isColorSchemeDark = useMatchMedia('(prefers-color-scheme: dark)')
  const [isStorageDark, setStorageDark] = useLocalStorage<boolean>(
    LocalStorageKeys.DARK_MODE,
  )

  const isDarkMode = isStorageDark ?? isColorSchemeDark ?? false

  const toggle = useCallback(() => {
    setStorageDark(!isDarkMode)
  }, [isDarkMode, setStorageDark])

  return {
    isDarkMode,
    toggle,
  }
}
